/* ===========================================================================
   cart-trust.js — Schalterlogik fuer den Versandschutz im Warenkorb-Drawer

   Aufgaben:
   1. Versandschutz automatisch hinzufuegen, sobald echte Ware im Korb liegt
      (sofern im Theme als "standardmaessig an" eingestellt).
   2. Ihn wieder entfernen, wenn keine echte Ware mehr da ist.
   3. Eine bewusste Abwahl des Kunden dauerhaft respektieren.

   Grundsatz: Dieses Skript fasst den Kassenknopf NICHT an und ruft nirgends
   preventDefault() auf dem Formular auf. Der Weg zur Kasse bleibt unberuehrt.
   =========================================================================== */

(function () {
  'use strict';

  if (window.cartTrustInit) return;
  window.cartTrustInit = true;

  var OPT_OUT_KEY = 'wv:cart-protect:opt-out';
  var busy = false;
  var failed = false;
  var syncTimer = null;

  function root() {
    return document.querySelector('[data-cart-protect]');
  }

  /* Abwahl ueberlebt Reload und Re-Render. localStorage kann im privaten
     Modus werfen - dann gilt schlicht "nicht abgewaehlt". */
  function optedOut() {
    try {
      return window.localStorage.getItem(OPT_OUT_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function setOptedOut(value) {
    try {
      if (value) {
        window.localStorage.setItem(OPT_OUT_KEY, '1');
      } else {
        window.localStorage.removeItem(OPT_OUT_KEY);
      }
    } catch (error) {
      /* ohne localStorage gilt die Abwahl nur fuer diese Seitenansicht */
    }
  }

  function setBusy(value) {
    busy = value;
    var el = root();
    if (el) el.dataset.busy = value ? 'true' : 'false';
  }

  function post(url, payload) {
    payload.sections = 'cart-drawer,cart-icon-bubble';
    payload.sections_url = window.location.pathname;

    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Warenkorb antwortete mit ' + response.status);
      return response.json();
    });
  }

  /* Stiller Austausch der Drawer-Inhalte.
     Bewusst NICHT cart-drawer.renderContents(): das oeffnet den Drawer. Beim
     automatischen Hinzufuegen soll sich der Warenkorb aber nicht von selbst
     aufklappen - der Kunde hat ihn nicht angefasst. */
  function applySections(data) {
    var sections = data && data.sections;
    if (!sections) return;

    var markup = sections['cart-drawer'];
    if (markup) {
      var parsed = new DOMParser().parseFromString(markup, 'text/html');

      var newItems = parsed.querySelector('cart-drawer-items');
      var oldItems = document.querySelector('#CartDrawer cart-drawer-items');
      if (newItems && oldItems) oldItems.innerHTML = newItems.innerHTML;

      var newFoot = parsed.querySelector('.cart-drawer__footer');
      var oldFoot = document.querySelector('#CartDrawer .cart-drawer__footer');
      if (newFoot && oldFoot) oldFoot.innerHTML = newFoot.innerHTML;

      var drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.toggle('is-empty', data.item_count === 0);

      var checkout = document.querySelector('#CartDrawer-Checkout');
      if (checkout) checkout.disabled = data.item_count === 0;
    }

    var bubbleMarkup = sections['cart-icon-bubble'];
    var bubble = document.querySelector('#cart-icon-bubble');
    if (bubbleMarkup && bubble) {
      var parsedBubble = new DOMParser().parseFromString(bubbleMarkup, 'text/html');
      var inner = parsedBubble.querySelector('.shopify-section');
      if (inner) bubble.innerHTML = inner.innerHTML;
    }
  }

  function addProtection(el) {
    setBusy(true);
    return post(el.dataset.addUrl, {
      items: [{ id: Number(el.dataset.variantId), quantity: 1 }]
    })
      .then(applySections)
      .catch(function () {
        failed = true;
      })
      .then(function () {
        setBusy(false);
      });
  }

  function removeProtection(el) {
    if (!el.dataset.lineKey) return Promise.resolve();
    setBusy(true);
    return post(el.dataset.changeUrl, { id: el.dataset.lineKey, quantity: 0 })
      .then(applySections)
      .catch(function () {
        failed = true;
      })
      .then(function () {
        setBusy(false);
      });
  }

  /* Gleicht den Warenkorb an den gewuenschten Zustand an. Laeuft nach jedem
     Re-Render des Drawers; `failed` verhindert eine Endlosschleife, falls der
     Warenkorb den Schreibvorgang dauerhaft ablehnt. */
  function sync() {
    if (busy || failed) return;

    var el = root();
    if (!el || el.dataset.available !== 'true') return;

    var regularCount = Number(el.dataset.regularCount || 0);
    var inCart = el.dataset.inCart === 'true';
    var defaultOn = el.dataset.defaultOn === 'true';

    if (regularCount === 0 && inCart) {
      removeProtection(el);
      return;
    }

    if (regularCount > 0 && !inCart && defaultOn && !optedOut()) {
      addProtection(el);
    }
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(sync, 180);
  }

  /* Delegiert, weil der Schalter bei jedem Re-Render ein neues Element ist. */
  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-cart-protect-toggle]');
    if (!toggle) return;

    var el = root();
    if (!el) return;

    failed = false;

    if (toggle.checked) {
      setOptedOut(false);
      addProtection(el);
    } else {
      setOptedOut(true);
      removeProtection(el);
    }
  });

  /* Dawn tauscht den Drawer-Inhalt auf drei verschiedenen Wegen aus und
     feuert dabei kein gemeinsames Ereignis. Ein Observer auf #CartDrawer
     deckt alle drei ab, ohne Theme-Dateien zu patchen. */
  function observe() {
    var target = document.querySelector('#CartDrawer');
    if (!target) return;
    new MutationObserver(scheduleSync).observe(target, { childList: true, subtree: true });
  }

  function init() {
    observe();
    scheduleSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
